/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetMcpServerRequest = {
  serverId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetMcpServerRequest$inboundSchema: z.ZodType<
  GetMcpServerRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  server_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "server_id": "serverId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetMcpServerRequest$Outbound = {
  server_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetMcpServerRequest$outboundSchema: z.ZodType<
  GetMcpServerRequest$Outbound,
  z.ZodTypeDef,
  GetMcpServerRequest
> = z.object({
  serverId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    serverId: "server_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getMcpServerRequestToJSON(
  getMcpServerRequest: GetMcpServerRequest,
): string {
  return JSON.stringify(
    GetMcpServerRequest$outboundSchema.parse(getMcpServerRequest),
  );
}
export function getMcpServerRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetMcpServerRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetMcpServerRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetMcpServerRequest' from JSON`,
  );
}
